import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['input', 'name', 'preview', 'placeholder']

  open() {
    this.inputTarget.click()
  }

  change() {
    const file = this.inputTarget.files && this.inputTarget.files[0]
    if (!file) return

    const partnerId = this.element.querySelector('[data-partner-logo-partner-id]')
    if (partnerId) partnerId.value = ''

    const signedId = this.element.querySelector('[data-partner-logo-signed-id]')
    if (signedId) signedId.value = ''

    if (this.hasNameTarget) {
      this.nameTarget.textContent = file.name
    }

    if (!file.type.startsWith('image/') || !this.hasPreviewTarget) return

    const reader = new FileReader()
    reader.onload = () => {
      this.previewTarget.src = reader.result
      this.previewTarget.hidden = false
      if (this.hasPlaceholderTarget) this.placeholderTarget.hidden = true
    }
    reader.readAsDataURL(file)
  }
}
